;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import {
    assetFragment,
    ctaFragment,
    linkFragment,
    simpleLinkFragment,
} from 'lib/graphql/fragments';

import BlockFeaturedCategoryNavigation from './BlockFeaturedCategoryNavigation';

const query = /* GraphQL */ `
    ${assetFragment}
    ${ctaFragment}
    ${linkFragment}
    ${simpleLinkFragment}
    query getBlock($id: String!, $preview: Boolean!) {
        blockFeaturedCategoryNavigation(preview: $preview, id: $id) {
            __typename
            anchorId
            headline
            cta {
                ...CTA
            }
            image {
                ...Asset
            }
            mediaPosition
            backgroundColor
            flushTop
            flushBottom
            linksCollection(limit: 10) {
                items {
                    ... on BlockFeaturedCategoryNavigationItem {
                        title
                        new
                        link {
                            ...SimpleLink
                        }
                        hoverImage {
                            ...Asset
                        }
                    }
                }
            }
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockFeaturedCategoryNavigation },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });
    return blockFeaturedCategoryNavigation;
}

const BlockFeaturedCategoryNavigationServer = async ({ id, ...rest }) => {
    const block = await fetchBlock(id);

    const { linksCollection, ...blockRest } = block;
    const links = linksCollection?.items?.filter(Boolean) ?? [];

    return (
        <BlockFeaturedCategoryNavigation
            {...blockRest}
            links={links}
            {...rest}
        />
    );
};

export default BlockFeaturedCategoryNavigationServer;
